import React from "react";
import ReusableList from "../ui/ReusableList";

export default function SubmissionList({ reports, user }) {
  return <ReusableList user={user} data={reports?.slice(0, 9)} />;
}
